import { httpClient as http } from '@/utils/http'
import type { AxiosRequestConfig } from 'axios'
import type {
  SupplierContractDetail,
  SupplierContractListItem,
  SupplierContractPageRequest,
  SupplierContractPageResult,
  SupplierContractSyncConfig,
  SupplierContractSyncConfigRequest,
  SupplierContractSyncLogItem,
  SupplierContractSyncLogPageRequest,
  SupplierContractSyncStatusSummary
} from '@/views/basic-data/supplier-contract-management/types'

export type {
  SupplierContractDetail,
  SupplierContractListItem,
  SupplierContractPageRequest,
  SupplierContractPageResult,
  SupplierContractQueryCondition,
  SupplierContractSort,
  SupplierContractSyncConfig,
  SupplierContractSyncConfigRequest,
  SupplierContractSyncLogItem,
  SupplierContractSyncLogPageRequest,
  SupplierContractSyncStatusSummary
} from '@/views/basic-data/supplier-contract-management/types'

const API_BASE = '/mdm/supplier-contract'
const unwrap = <T>(promise: Promise<unknown>) => promise as Promise<T>
type SupplierContractRequestConfig = AxiosRequestConfig & { showErrorMessage?: boolean }

export const supplierContractApi = {
  page: (request: SupplierContractPageRequest) =>
    unwrap<SupplierContractPageResult<SupplierContractListItem>>(http.post(`${API_BASE}/page`, request)),
  get: (contractNumber: string, showErrorMessage = true) =>
    unwrap<SupplierContractDetail>(http.get(`${API_BASE}/detail`, {
      params: { contractNumber }, showErrorMessage
    } as SupplierContractRequestConfig)),
  getSyncConfig: () =>
    unwrap<SupplierContractSyncConfig>(http.get(`${API_BASE}/sync/config`)),
  updateSyncConfig: (request: SupplierContractSyncConfigRequest) =>
    unwrap<SupplierContractSyncConfig>(http.put(`${API_BASE}/sync/config`, request)),
  getSyncStatus: (batchId?: string, showErrorMessage = true) =>
    unwrap<SupplierContractSyncStatusSummary>(http.get(`${API_BASE}/sync/status`, {
      params: batchId ? { batchId } : undefined,
      showErrorMessage
    } as SupplierContractRequestConfig)),
  refresh: (contractNumber: string, showErrorMessage = true) =>
    unwrap<SupplierContractSyncStatusSummary>(http.post(`${API_BASE}/refresh`, undefined, {
      params: { contractNumber },
      showErrorMessage
    } as SupplierContractRequestConfig)),
  triggerSync: () =>
    unwrap<SupplierContractSyncStatusSummary>(http.post(`${API_BASE}/sync/trigger`)),
  pageSyncLogs: (request: SupplierContractSyncLogPageRequest) =>
    unwrap<SupplierContractPageResult<SupplierContractSyncLogItem>>(
      http.post(`${API_BASE}/sync/log/page`, request)
    )
}
